<!--
  author:
  des:
  param:
-->
<template>
  <div class="form-group">
    <div class="input-control" :class="{fit: hasFit}" @click="toggle">{{context}}</div>
    <ul class="dropdown-menu-vue" v-show="show">
      <li v-for="(item, index) in list" @click="bindV(item)">{{item.value}}</li>
    </ul>
    <div class="error" v-show="error">* {{error}}</div>
  </div>
</template>

<script>
  export default {
    name: 'Select',
    props: {
      list: {
        type: Array,
        default: []
      },
      contextP: '',
      error: ''
    },
    data() {
      return {
        show: false,
        context: this.contextP,
        hasFit: false
      }
    },
    methods: {
      toggle() {
        this.show = !this.show
      },
      bindV(item) {
        this.$emit('chooseV', item)
        this.context = item.value
        this.show = false
        this.hasFit = true
      }
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  * {
    box-sizing: border-box;
  }
  .form-group {
    margin-bottom: 25px;
    position: relative;
    .error {
      position: absolute;
      top: 32px;
      padding: 2px 6px 0;
      color: red;
    }
    .input-control {
      background-color: #fff;
      height: 32px;
      line-height: 32px;
      width: 100%;
      border: 1px solid #c6c9cc;
      color: #cdcdcd;
      cursor: pointer;
      display: block;
      font-size: 12px;
      padding: 0 6px;
      position: relative;
      &::after {
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid;
        display: inline-block;
        height: 0;
        margin-left: 2px;
        vertical-align: middle;
        width: 0;
        content: '';
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .dropdown-menu-vue {
      top: 33px;
      width: 100%;
      border: 1px solid #c6c9cc;
      border-top: none;
      color: #cdcdcd;
      cursor: pointer;
      font-size: 12px;
      line-height: 24px;
      max-height: 240px;
      overflow-y: auto;
      z-index: 99;
      position: absolute;
      background-color: #ffffff;
      li {
        height: 30px;
        line-height: 30px;
        padding: 0 6px;
        color: #818181;
        &:hover {
          background-color: #f5f7f7;
        }
      }
    }
    .btn {
      border: 1px solid transparent;
      border-radius: 4px;
      cursor: pointer;
      display: inline-block;
      margin-bottom: 0;
      vertical-align: middle;
      white-space: nowrap;
      background-color: #ff9c00;
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      height: 42px;
      line-height: 42px;
      padding: 0;
      text-align: center;
      width: 100%;
      &:hover {
        background-color: #f78400;
      }
    }
    .fit {
      color: #333333;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/select.vue